import DetailsPageLowerLayer from "../../../Components/DetailsPageLowerLayer/DetailsPageLowerLayer";
import Toolbar from "../../../CommonComponents/common/Toolbar";
import { Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TopSection from "../../../CommonComponents/TopSection";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import CollapsibleHeader from "../../../CommonComponents/common/CollapsibleHeader";
import useRedirect from "../../../CustomHooks/useRedirect";
import OutboundDeliveryHeader from "./OutboundDeliveryHeader";
import {
  fetchHeaderData,
  fetchDeliveryLinesData,
} from "../../../services/OutboundDeliveries/OutboundDeliveryDetailService";
import SectionSpinner from "../../../CommonComponents/common/Loader/SectionSpinner";
import { formatValue } from "../../../utils/currencyUtils";

const OutboundDeliveryDetail = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [headerData, setHeaderData] = useState({});
  const [deliveryLinesRows, setDeliveryLinesRows] = useState([]);
  const [exceptionType, setExceptionType] = useState("");
  // Separate loading states for each section
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingLines, setLoadingLines] = useState(false);
  const navigate = useNavigate();
  const redirect = useRedirect();
  const { id, shipFrom } = useParams();
  //const location = useLocation();
  //const shipFrom = location.state?.shipFrom || "";

  const breadcrumbArray = [
    "Demand",
    "Outbound Deliveries",
    "Outbound Deliveries Detail",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingDetails(true);
        setLoadingLines(true);
        // const encodedShipFrom = encodeURIComponent(shipFrom);
        // console.log("URL Construction - Delivery ID:", id, "Ship From Value:", shipFrom);
        const header = await fetchHeaderData(id, shipFrom);
        setLoadingDetails(false);
        setHeaderData(header);
        setExceptionType(header?.exceptionType);

        const response = await fetchDeliveryLinesData(id);
        const lines = Array.isArray(response) ? response : [];

        const formattedLinesRows = lines?.map((item) => ({
          line_no: item.lineNo,
          line_state: item.lineState,
          erp_line_state: item.erpLineState,
          so_no: item.soNo,
          so_line: item.soLine,
          so_order_type: item.soOrderType,
          so_customer: item.soCustomer,
          so_supplier: item.soSupplier,
          order_uom: item.orderUOM,
          shipped_qty: formatValue(item.shippedQuantity),
          item: item.item,
          supplier_item_name: item.supplierItemName,
          supplier_item_owner: item.supplierItemOwner,
          material_class: item.materialClass,
        }));
        setLoadingLines(false);
        setDeliveryLinesRows(formattedLinesRows);
      } catch (error) {
        console.error("Error fetching delivery detail:", error);
      }
    };

    fetchData();
  }, [id, shipFrom]);

  const redirectFn = useMemo(() => {
    return (path, state) => redirect(path, state);
  }, [redirect]);

  const toolbarProps = {
    number: id,
    status: exceptionType,
    icon: <LocalShippingIcon />,
    onBack: () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/core/demand/delivery");
      }
    },
    isCollapsed,
    toggleHeader: () => setIsCollapsed((prev) => !prev),
  };

  const linesTab = useMemo(
    () => ({
      label: `Delivery Lines (${deliveryLinesRows?.length ?? 0})`,
      loading: loadingLines,
      columns: [
        { field: "line_no", headerName: "Line No" },
        { field: "line_state", headerName: "Line State" },
        { field: "erp_line_state", headerName: "ERP Line State" },
        {
          field: "so_no",
          headerName: "SO No",
          cellRenderer: (params) => {
            const { value } = params;
            const redirect = params.colDef.cellRendererParams?.redirect;
            return (
              <span
                onClick={() =>
                  redirect(`/core/demand/order/order-detail/${value}`, {
                    menu: "Demand",
                    label: "Sales Orders",
                    outerLabel: "Sales Orders Detail",
                    previousPage: window.location.pathname,
                  })
                }
                style={{
                  color: "#1976d2",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {value}
              </span>
            );
          },
          cellRendererParams: { redirect: redirectFn },
        },
        { field: "so_line", headerName: "SO Line" },
        { field: "so_order_type", headerName: "SO Order Type" },
        { field: "so_customer", headerName: "SO Customer" },
        { field: "so_supplier", headerName: "SO Supplier" },
        { field: "order_uom", headerName: "Order UOM" },
        { field: "shipped_qty", headerName: "Shipped Qty" },
        { field: "item", headerName: "Material Number" },
        { field: "supplier_item_name", headerName: "Supplier Item Name" },
        { field: "supplier_item_owner", headerName: "Supplier Item Owner" },
        { field: "material_class", headerName: "Material Class" },
        // { field: "hazmat", headerName: "Contains Hazmat" },
        // { field: "temp_controlled", headerName: "Temp Controlled" },
      ],
      rows: deliveryLinesRows
    }), [loadingLines, deliveryLinesRows, redirectFn]
  );

  const tabs = [linesTab];

  return (
    <div>
      <TopSection
        breadcrumbArray={breadcrumbArray}
        hideHeader={true}
        headerName={""}
        hideTitle={true}
      />
      <Toolbar {...toolbarProps} />
      <CollapsibleHeader
        upperLayer={
          <Box sx={{ position: "relative" }}>
            {loadingDetails && <SectionSpinner />}
            <OutboundDeliveryHeader hProps={headerData} />
          </Box>
        }
        lowerLayer={<DetailsPageLowerLayer tabs={tabs} />}
        isCollapsed={isCollapsed}
      />
    </div>
  );
};

export default OutboundDeliveryDetail;
